import scssVariables from "@/assets/styles/variables.module.scss"

import isBuilderContext from "@/lib/is-platform/is-builder-context"

const toInt = value => parseInt(value.replace("px", ""))

export default {
  namespaced: true,

  state: {
    isMobile: false,
    isTablet: false,
    isDesktop: false
  },

  mutations: {
    setResponsiveState(state, { width }) {
      if (isBuilderContext()) return

      state.isMobile = width <= toInt(scssVariables["breakpoint--md"])
      state.isTablet =
        !state.isMobile && width <= toInt(scssVariables["breakpoint--xl"])
      state.isDesktop = width >= toInt(scssVariables["breakpoint--xl"])
    },

    forceResponsiveState(state, { isMobile, isTablet, isDesktop }) {
      state.isMobile = isMobile
      state.isTablet = isTablet
      state.isDesktop = isDesktop
    }
  }
}
